<template>
  <div class="no-results">
    <div
      v-if="icon"
      class="no-results--icon"
    >
      <q-icon :name="icon" />
    </div>
    <div
      v-if="title"
      class="no-results--title"
    >
      {{ title }}
    </div>
    <div
      v-if="caption"
      class="no-results--caption"
    >
      {{ caption }}
    </div>
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
  icon: { type: String, default: null },
  title: { type: String, default: null },
  caption: { type: String, default: null }
})

defineOptions({ name: 'NoResults' })

</script>

<style scoped>
@reference "#app-styles.css";

.no-results {
  @apply flex flex-col items-center justify-center gap-1 py-10 text-center;

  .no-results--icon { @apply text-[32px] text-ink-subtle; }
  .no-results--title { @apply ink-strong text-[14px] font-medium; }
  .no-results--caption { @apply ink-subtle text-[13px]; }
}
</style>
